import { styled } from "styled-components";

export const CouponTypeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(240, 242, 241, 1);
`;
